@let subItems = item().subNavItems;

<p-panel
  [id]="hasNoSubItems() ? 'navItem' : 'navItem-toggleable'"
  [toggleable]="!!subItems?.length"
  [toggler]="'header'"
  [(collapsed)]="isCollapsed"
  expandIcon="pi pi-angle-up"
  collapseIcon="pi pi-angle-down"
  [styleClass]="
    isCollapsed()
      ? ''
      : hasNoSubItems()
        ? 'is-selected'
        : 'is-dropdown-selected'
  "
  (onBeforeToggle)="toggleNavItem($event)"
>
  <ng-template pTemplate="header">
    <div
      [style]="{
        display: 'flex',
        gap: '10px',
        alignItems: 'center'
      }"
      class="header-wrapper"
    >
      <i [class]="item().icon"></i>
      {{ item().title }}
    </div>
  </ng-template>
  @if (subItems?.length) {
    <div class="nav-items-container">
      @for (subItem of subItems || []; track subItem.title) {
        @let subItemFullUrl = "/" + item().url.concat(subItem.url).join("/");

        <div
          (click)="subNavigate($event, subItem.url)"
          [ngClass]="{
            'sub-item': true,
            'item-selected':
              currentRoute() === subItemFullUrl ||
              currentRoute().startsWith(subItemFullUrl),
            'last-item': $index === (subItems && subItems.length - 1)
          }"
        >
          <i [class]="subItem.icon"></i>
          {{ subItem.title }}
        </div>
      }
    </div>
  }
</p-panel>
